import React, { Component } from 'react';
import { observer } from 'mobx-react';
import userstore from '../store/user-store';
import { Button, Form, Input, Checkbox } from 'semantic-ui-react';
import eb from '../utils/EventBus';
import { withRouter } from 'react-router-dom'

class UserUpdate extends Component {

	componentDidMount() {
		const { match } = this.props;
		userstore.loadUser(match.params.id);
		eb.on('user-updated', () => this.props.history.push('/user'));
	}

	render() {
		const usr = userstore.selectedUser;
		return (
			//<div className="user">
			//<div class="ui left aligned container">
			<div className="buyer-invoice">
                <div className="title">
					<h4 align="left">Update User</h4>
				</div>
				<div class="row">

				</div>
				{usr && (
					<Form>
						<Form.Field inline>
							<label>First Name  </label>
							<Input className="w-100" value={usr.firstname} onChange={(evt, { value }) => userstore.setFirstName(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Last Name  </label>
							<Input className="w-100" value={usr.lastname} onChange={(evt, { value }) => userstore.setLastName(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Email Address</label>
							<Input className="w-100" value={usr.email} onChange={(evt, { value }) => userstore.setEmailAddress(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Username</label>
							<Input className="w-100" value={usr.username} onChange={(evt, { value }) => userstore.setUsername(value)} />
						</Form.Field>

                                                <Form.Field inline>
							<label>New Password</label>
							<Input type="password" value={usr.newpassword || ''} onChange={(evt, { value }) => userstore.setNewPassword(value)} />
						</Form.Field>
                                               
 
						<Form.Field inline>
							<label>Work Phone#</label>
							<Input className="w-100" value={usr.workphone} onChange={(evt, { value }) => userstore.setWorkPhoneNumber(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Mobile Phone#</label>
							<Input className="w-100" value={usr.mobilephone} onChange={(evt, { value }) => userstore.setMobilePhoneNumber(value)} />
						</Form.Field>

						<Form.Field inline>
							<label>Active</label>
							<Input className="w-100" value={usr.activeflag} />
						</Form.Field>

                        <Button className="save" primary onClick={userstore.updUser}>Save</Button>
						
					</Form>
				)}
				<div className="footer">
					
				</div>
			</div>
		);
	}
}


export default withRouter(observer(UserUpdate));



// WEBPACK FOOTER //
// ./src/containers/UserUpdate.js